import { render, staticRenderFns } from "./ConfirmPurchaseIcon.vue?vue&type=template&id=0b0df4f9&scoped=true"
import script from "./ConfirmPurchaseIcon.vue?vue&type=script&lang=js"
export * from "./ConfirmPurchaseIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b0df4f9",
  null
  
)

export default component.exports